import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';

@Injectable({
  providedIn: 'root'
})
export class RSAHelperService {

  publicKey:   string = `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDatFVVUUlFsf/AA8O2f
  BnC76fFT4Bnq5fGH+xb4AwIGiCDu+d1mydGIegu21hg+o7I6F+BoE5CiCsh+soviWKkribnZIH
  PD8V9wz0Owqz+thHze0EuIgB+B2dWMXbu1kgP4ckwVOIjfSYAuOvv61+n7aUgAJcDVEgpOTtL2kOZfwIDAQAB
  -----END PUBLIC KEY-----`
  
  privateKey:   string = `-----BEGIN RSA PRIVATE KEY-----
  MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBANq0VVVRSUWx/8AD
  w7Z8GcLvp8VPgGerl8Yf7FvgDAgaIIO753WbJ0Yh6C7bWGD6jsjoX4GgTkKIKyH6
  yi+JYqSuJudkgc8PxX3DPQ7CrP62EfN7QS4iAH4HZ1Yxdu7WSA/hyTBU4iN9JgC4
  6+/rX6ftpSAAlwNUSCk5O0vaQ5l/AgMBAAECgYAwz9zXzOugnYiqL2zn9qy9QEXe
  mM7c1IRsWMWk/81PpZ0qKa8QJY/PbFPo2VXRVzq1BoACa2fsG34c+F9V2sDj/Kxh
  V7f/pNaQ+Nb5u8CExa79mohLHXX+M9hIYP2DdleBSKpxAzxRs6OWzCirh+mF4RdM
  HTF1W60Muk7eqAc3qQJBAPdoyScsxQUseoC+GNWKQC5nOQjY6BP8BE46m93Itr9P
  t62VrySpistWRHZV6crr11ZLCenDHVKTQJDJJ1JPaU0CQQDiTGQAFk5fIMuvJgYI
  ZjRvw3QUh27kFMIUNgR1xq3GX9/tkYNLU2AcmlRbGRVcV8fLZj8a4M4hulzCWw7v
  f0f7AkEA5bNFvrdUHF+VRN45VFjNCcgQLeSkY5mBrdfASoNFGA29LM5iE5nNIMfx
  PCS7sQiRnq6Af6YFHVtVgJchiMvtqQJBAI/p4NalWOXqZ15VohSJWuOQuyurDXyD
  LwHHcIKt/SlhI3ljxsmKll7aTrc4dnspX+gceBlRygVtDTyUyCTLHy0CQQDy67R1
  89UOoHaoUzVV2LyGX7a5m03uCNPZyjVwRbLb0dVgFkPST0ooJ/Y9uR65J+mAWkTv
  TBbkeunxXuX9LBI7
  -----END RSA PRIVATE KEY-----`
  constructor() {}

  encryptWithPublicKey(valueToEncrypt: string): string {
    const rsa = Forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
}


decryptWithPrivateKey(valueToDecrypt: string): string {
  const privateKey = Forge.pki.privateKeyFromPem(this.privateKey);
  const decodeText = Forge.util.decode64(valueToDecrypt);
  const decrypted = privateKey.decrypt(decodeText);
  return  decrypted;
  
  /* const rsa = Forge.pki.privateKeyFromPem(this.privateKey);
  return window.btoa(rsa.decrypt(valueToDecrypt.toString())); */
}
}